var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"fill-height"},[(_vm.$store.getters.activescreen==='explorer')?_c('ExplorerScreen'):(_vm.$store.getters.activescreen==='assettype')?_c('AssetTypeScreen'):_c('DashboardScreen')],1)}
var staticRenderFns = []

export { render, staticRenderFns }